import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
  standardTransition,
} from '../styles';
import { ArrowButton, Container, Heading } from './ui';
import BlogCard from './BlogCard';

const StyledFeaturedBlogPosts = styled.section`
  ${sectionPaddings()};
  background-color: ${standardColours.lightGrey};
`;

const StyledInner = styled.div`
  display: grid;
  gap: 30px;

  ${maxBreakpointQuery.medium`
    justify-items: center;
  `};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(3, 1fr);
  `};

  ${({ isBlogDetail }) => {
    if (!isBlogDetail) {
      return css`
        ${minBreakpointQuery.medium`
          grid-area: 2/1/2/3;
        `};
      `;
    }
  }}
`;

const StyledButton = styled(ArrowButton)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        background-color: ${standardColours.transparent};
        border: solid 1px ${standardColours.darkGrey};
        transition: ${standardTransition('background-color')},
          ${standardTransition('border-color')};

        &:hover {
          border-color: ${standardColours.transparent};
        }
        ${minBreakpointQuery.medium`
          justify-self: start;
        `};
      `;
    } else {
      return css`
        ${minBreakpointQuery.medium`
          justify-self: end;
        `};
      `;
    }
  }}
`;

const FeaturedBlogPosts = ({ heading, items, isBlogDetail }) => {
  const {
    allDatoCmsBlog: { nodes },
    datoCmsBlogListing,
  } = useStaticQuery(graphql`
    query FeaturedBlogPostsQuery {
      allDatoCmsBlog(sort: { meta: { createdAt: DESC } }, limit: 3) {
        nodes {
          ...BlogFragment
        }
      }
      datoCmsBlogListing {
        slug
      }
    }
  `);

  const posts = items && items.length > 0 ? items : nodes;

  return (
    <StyledFeaturedBlogPosts>
      <Container>
        <StyledInner>
          <Heading>
            {heading ||
              (items && items.length > 0
                ? 'Related blog posts'
                : 'Latest blog posts')}
          </Heading>
          <StyledItems isBlogDetail={isBlogDetail}>
            {posts.map((post, id) => (
              <BlogCard key={id} {...post} />
            ))}
          </StyledItems>
          <StyledButton
            to={datoCmsBlogListing.slug}
            isBlogDetail={isBlogDetail}
            alt={isBlogDetail}
          >
            {isBlogDetail ? 'Back to all blog posts' : 'View all blog posts'}
          </StyledButton>
        </StyledInner>
      </Container>
    </StyledFeaturedBlogPosts>
  );
};

export default FeaturedBlogPosts;
